export default {
  defaultProps: {
    colorScheme: 'primary',
    borderRadius: 'lg',
  },
  variants: {
    solid: ({ colorScheme }: Record<string, any>) => ({
      _light: {
        bg: `${colorScheme}.500`,
        _hover: {
          bg: `${colorScheme}.700`,
        },
        _pressed: {
          bg: `${colorScheme}.700`,
        },
        _focus: {
          bg: `${colorScheme}.700`,
        },
        _text: {
          fontWeight: 'bold',
        },
      },
    }),
    ghost: ({ colorScheme }: Record<string, any>) => ({
      _light: {
        _hover: {
          bg: `${colorScheme}.100`,
        },
        _pressed: {
          bg: `${colorScheme}.100`,
        },
        _focus: {
          bg: `${colorScheme}.100`,
        },
        _text: {
          fontWeight: 'bold',
          color: `${colorScheme}.500`,
        },
      },
    }),
    link: ({ colorScheme }: Record<string, any>) => ({
      _light: {
        _text: {
          color: `${colorScheme}.500`,
          textDecorationLine: 'underline',
        },
        _hover: {
          _text: {
            color: `${colorScheme}.700`,
          },
        },
        _focus: {
          _text: {
            color: `${colorScheme}.700`,
          },
        },
      },
    }),
    outline: ({ colorScheme }: Record<string, any>) => ({
      _light: {
        _text: {
          fontWeight: 700,
          color: `${colorScheme}.500`,
        },
        _hover: {
          bg: `${colorScheme}.100`,
          _text: {
            color: `${colorScheme}.700`,
          },
        },
        _focus: {
          borderColor: `${colorScheme}.700`,
          _text: {
            color: `${colorScheme}.700`,
          },
        },
        _pressed: {
          bg: `${colorScheme}.100`,
        },
        borderColor: `${colorScheme}.500`,
      },
    }),
    light: () => ({
      bg: 'white',
      _text: {
        color: 'primary.700',
        fontWeight: 'bold',
      },
      _hover: {
        bg: 'white:alpha.90',
      },
      _pressed: {
        bg: 'white:alpha.80',
      },
    }),
  },
  sizes: {
    xl: {
      px: 6,
      py: 4,
      _text: {
        fontSize: 'xl',
      },
    },
    lg: {
      px: 6,
      py: 5,
      _text: {
        fontSize: 'xl',
      },
    },
    md: {
      px: 6,
      py: 3,
      _text: {
        fontSize: 'md',
      },
    },
    sm: {
      px: 4,
      py: 2,
      _text: {
        fontSize: 'sm',
      },
    },
    xs: {
      px: 2,
      py: 1,
      _text: {
        fontSize: 'xs',
      },
    },
  },
}
